import { useApi } from "@/lib/useApi";
import { Card } from "@/components/ui/card";
import { PageHeader, EmptyState } from "@/components/common";
import { StatusPill } from "@/components/StatusPill";
import { fPct } from "@/lib/format";
import { AlertTriangle, ShieldCheck } from "lucide-react";

export default function RotationWarnings() {
  const { data, loading } = useApi("/rotation/metrics?period=rullande28");
  if (loading) return <p className="text-muted-foreground">Beräknar rotation…</p>;
  const list = (data || []).filter((m) => m.event_count > 0);
  const flagged = list.filter((m) => m.level !== "gron");

  return (
    <div>
      <PageHeader title="Rotationsvarningar" icon={AlertTriangle}
        subtitle="Transparent beräkning: Andel tungt arbete = minuter i tungt klassade moment / totalt klassificerade minuter. Raster och oklassificerad tid ingår inte i nämnaren." />
      {list.length === 0 ? (
        <EmptyState icon={ShieldCheck} title="Inga beräknade data ännu"
          text="Importera faktiskt arbete (arbetshändelser) för att beräkna belastning och rotation." />
      ) : flagged.length === 0 ? (
        <Card className="flex items-center gap-3 border-emerald-200 bg-emerald-50 p-5">
          <ShieldCheck className="h-6 w-6 text-emerald-600" />
          <span className="font-medium text-emerald-800">Inga överskridna eller nära rotationsgränser för närvarande.</span>
        </Card>
      ) : (
        <div className="space-y-3">
          {flagged.map((m) => (
            <Card key={m.employee_id} className="p-4" data-testid={`warning-${m.employee_id}`}>
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div className="font-head font-semibold">{m.employee_id}</div>
                <StatusPill level={m.level} size="lg" />
              </div>
              <p className="mt-2 text-sm">
                Medarbetaren har arbetat <span className="font-mono font-bold">{fPct(m.heavy_pct)}</span> av sin klassificerade arbetstid i
                tungt belastade områden de senaste 28 dagarna. Rotationsgränsen är <span className="font-mono font-bold">{m.rotation_limit_pct}%</span>.
                {m.level === "rod" ? " Planeringen behöver justeras – planera fler timmar i lätt eller medeltungt område kommande period."
                  : " Belastningen närmar sig gränsen – öka arbetsvariationen kommande period."}
              </p>
              <div className="mt-2 flex flex-wrap gap-x-6 gap-y-1 text-xs text-muted-foreground">
                <span>Datatäckning: <span className="font-mono text-foreground">{fPct(m.data_coverage_pct)}</span></span>
                <span>Lätt {fPct(m.share_pct.latt)} · Medel {fPct(m.share_pct.medel)} · Tung {fPct(m.share_pct.tung)}</span>
                <span>Byten mellan områden: <span className="font-mono text-foreground">{m.station_switches}</span></span>
              </div>
              <p className="mt-2 text-[11px] uppercase tracking-wide text-amber-700">Förhöjd belastningsexponering · behov av ökad arbetsvariation</p>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
